/**
 * Contact + Demo (BookDemo) actions
 */
export const CONTACT_ACTIONS = {
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  FORM_SUCCESS: 'form_success',
  FORM_FAILED: 'form_failed',
  EMAIL_CLICKED: 'email_clicked',
  DEMO_CLICKED: 'demo_clicked',
} as const;

export const DEMO_ACTIONS = {
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  SUBMISSION_SUCCESS: 'submission_success',
  SUBMISSION_FAILED: 'submission_failed',
} as const;
